import React, { useEffect, useRef, useState } from 'react';

interface SearchProps extends Record<string, unknown> {
  value: string;
  placeholder: string;
  onValueChange: (value: string) => void;
  id?: string;
  className?: string;
  autoFocus?: boolean;
  ariaLabel?: string;
  dataTestId?: string;
}

const Search: React.FC<SearchProps> = ({
  value,
  onValueChange,
  placeholder,
  id,
  className,
  autoFocus,
  ariaLabel,
  dataTestId
}) => {
  const searchInputRef = useRef<HTMLInputElement>(null);
  const [inputValue, setInputValue] = useState(value);

  useEffect(() => {
    setInputValue(value);
  }, [value]);

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    onValueChange(value);
    setInputValue(value);
  };

  const handleClearSearch = () => {
    onValueChange('');
    setInputValue('');
  };

  return (
    <div className={`search-container${className ? ` ${className}` : ''}`}>
      <div className="search-icon">
        <i className="fa-light fa-magnifying-glass"></i>
      </div>
      <input
        ref={searchInputRef}
        type="text"
        value={inputValue}
        onChange={handleInputChange}
        placeholder={placeholder}
        id={id}
        autoFocus={autoFocus}
        aria-label={ariaLabel}
        data-testid={dataTestId}
      />
      {inputValue !== '' && (
        <i
          className="fa-light fa-times search-clear"
          onClick={handleClearSearch}
          title="Clear"
        ></i>
      )}
    </div>
  );
};

export default Search;
